<template>
  <div id="callSendMessage" class="contact-form custom-form-style">
    <div class="contact-form-success alert alert-success d-none mt-4" id="contactFormSuccess">
      <strong>{{ trans('Success!') }}</strong> {{ trans('Your message has been sent to us.') }}
    </div>

    <div class="contact-form-error alert alert-danger d-none mt-4" id="contactFormError">
      <strong>{{ trans('Error!') }}</strong> {{ trans('There was an error sending your message.') }}
      <span class="mail-error-message text-1 mt-2 d-block" id="contactFormErrorMessage"></span>
    </div>

    <input type="hidden" name="subject" :value="trans('Contact Message Received')"/>
    <ValidationObserver v-slot="{ invalid, validate }">
      <div class="form-content">
        <div class="form-control-custom custom-sm-margin-bottom-2">
          <i class="far fa-user"></i>
          <ValidationProvider mode="passive" :name="trans('Name')" rules="required|min:3" v-slot="{ errors }">
            <input type="text" class="form-control"
                   id="name" name="name" v-model="name"
                   :placeholder="trans('Your name') + ' *'"
                   required />
            <label class="error">{{ errors[0] }}</label>
          </ValidationProvider>
        </div>

        <div class="form-control-custom custom-sm-margin-bottom-2">
          <i class="far fa-envelope"></i>
          <ValidationProvider mode="passive" :name="trans('E-mail')" rules="required|email" v-slot="{ errors }">
            <input type="email" class="form-control"
                   id="email" name="email" v-model="email"
                   :placeholder="trans('Your E-mail') + ' *'"
                   :data-msg-required="trans('This field is required')"
                   required />
            <label class="error">{{ errors[0] }}</label>
          </ValidationProvider>
        </div>

        <div class="form-control-custom custom-sm-margin-bottom-2">
          <i class="far fa-question-circle"></i>
          <ValidationProvider mode="passive" :name="trans('Topic')" rules="required|min:3" v-slot="{ errors }">
            <v-select v-model="topic"
                      class="form-control feedback-select"
                      :placeholder="trans('What\'s your problem?')"
                      :searchable="false"
                      :clearable="false"
                      :options="[trans('Give a tip about the stolen vehicle'), trans('General Request')]" />
            <label class="error">{{ errors[0] }}</label>
          </ValidationProvider>
        </div>

        <div class="form-control-custom custom-sm-margin-bottom-2">
          <i class="far fa-comment-dots"></i>
          <ValidationProvider mode="passive" :name="trans('Message')" rules="required|min:10" v-slot="{ errors }">
            <input type="text" class="form-control"
                   id="message" name="message" v-model="message"
                   :placeholder="trans('Your message') + ' *'"
                   :data-msg-required="trans('This field is required')"
                   required />
            <label class="error">{{ errors[0] }}</label>
          </ValidationProvider>
        </div>

        <input
          type="submit"
          class="btn custom-btn-style-1 custom-btn-padding-1 custom-btn-bg-color-1 text-color-light text-uppercase font-weight-semibold outline-none mt-4"
          :value="loading ? trans('Loading...') : trans('Submit')"
          @click.prevent="() => submitButtonHandler(validate)"
        />
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { apiClient } from '../api';

  import { extend } from 'vee-validate';
  import { required, email, min } from 'vee-validate/dist/rules';

  extend('required', required);
  extend('email', email);
  extend('min', min);


  export default {
    name: "FeedbackForm",

    props: {
      feedbackRoute: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        loading: false,
        name: null,
        email: null,
        topic: null,
        message: null,
      }
    },

    methods: {
      submitButtonHandler(validate) {
        if (this.loading) {
          return;
        }

        validate()
          .then(result => {
            if (result) {
              return this.sendData();
            } else {
              Vue.nextTick(() =>
                this.$toasted.show(
                  this.trans('Validation Error'),
                  { type: 'error' }
                )
              );
            }
          });
      },

      async sendData() {
        this.loading = true;

        apiClient
          .post(this.feedbackRoute, {
            name: this.name,
            email: this.email,
            topic: this.topic,
            message: this.message,
          })
          .then(response => {
            this.name = null;
            this.email = null;
            this.topic = null;
            this.message = null;

            Vue.nextTick(() => {
              this.$toasted.show(
                this.trans('Your feedback has been received and registered in our system.'),
              );
            });
          })
          .catch(error => {
            if (error.response.status === 422) {
              const data = error.response.data;

              Vue.nextTick(() =>
                this.$toasted.show(
                  this.trans('Validation Error'),
                  { type: 'error' }
                )
              );
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }
  }
</script>
